import { mapRdvToCommande } from './equipeRdvRules.js';
import { getRdvPaymentView } from './rdvPaymentDisplay.js';

/**
 * Prédicat unique — compteur « Paiement à finaliser » + filtre planning.
 * S'appuie sur paymentQuote canonique (API), pas sur amountDueNow HOLD figé seul.
 */
export function rdvNeedsPaymentFollowUp(rdv) {
  const commande = mapRdvToCommande(rdv);
  const view = getRdvPaymentView(commande);
  if (!view || view.isRefunded) return false;

  const total = Number(view.total) || 0;
  const paid = Number(view.amountPaid) || 0;
  const dueLater = Number(view.amountDueLater) || 0;

  if (total > 0 && paid >= total - 0.009) return false;
  if (String(view.paymentStatus || '').toUpperCase() === 'PAID') return false;

  const statut = String(rdv?.statut || commande?.statut || '').toUpperCase();
  if (statut === 'EN_ATTENTE_PAIEMENT' && dueLater > 0.009) return true;

  if (dueLater > 0.009) {
    if (view.modePaiement === 'enligne') return true;
    if (paid > 0.009) return true;
    if (String(view.paymentStatus || '').toUpperCase() === 'AWAITING_PAYMENT') {
      return view.modePaiement !== 'surplace';
    }
  }

  return false;
}
